// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"13cbe0d6","453":"ebf6d3f9","455":"8bd2155a","977":"104b2a2b"}[chunkId] + ".chunk.js";
};